import React, {Component} from 'react'
import {Button} from 'antd'

import style from './controls.sass'

class Controls extends Component {
  zoomIn = () => {
    const {xExtents} = this.props
    const [left, right] = xExtents
    let diff
    if ((right - left) <= 5) {
      diff = 0
    } else {
      diff = Math.floor((right - left)/5)
    }
    this.props.changeState({xExtents: [left + diff, right - diff]})
  }
  zoomOut = () => {
    const {xExtents: [left, right], data} = this.props

    const diff = Math.floor((right - left)/5) || 2
    const newRight = Math.min(right + diff, data.length - 1)
    const newLeft = Math.max(left - diff, 0)

    this.props.changeState({xExtents: [newLeft, newRight]})
  }
  enableBrush = () => {
    this.props.changeState({brushEnabled: true})
  }
  reset = () => {
    const {xExtents} = this.props.originalExtents
    const suffix = this.props.suffix + 1
    this.props.changeState({xExtents, suffix})
  }
  render() {
    return(
      <div styleName='controls'>
        <Button
          icon='plus-circle-o'
          onClick={this.zoomIn}
        />
        <Button
          icon='minus-circle-o'
          onClick={this.zoomOut}
        />
        <Button
          icon='search'
          onClick={this.enableBrush}
        />
        <Button
          icon='reload'
          onClick={this.reset}
        />
      </div>
    )
  }
}

export default Controls
